/* eslint-disable @typescript-eslint/naming-convention */
import type { Image } from '@ps/web-martech-cms-types';
import { isNull } from 'lodash';
import React from 'react';

import type { ClassNameProp } from '@swf/core/types/Props';

import CMSPreloadImage from '../CMSPreloadImage/CMSPreloadImage';

import styles from './CMSImage.scss';

type Props = Image &
  Partial<ClassNameProp> & { onClick?(e: React.MouseEvent<HTMLImageElement, MouseEvent>): void };

const CMSImage: React.FC<Props> = ({ asset, alt, width, height, className, onClick }) => {
  if (asset) {
    const dimensions = {
      width: isNull(width) ? undefined : width,
      height: isNull(height) ? undefined : height
    };

    return (
      <>
        <CMSPreloadImage imageUrl={asset.url} />
        <img
          src={asset.url}
          alt={alt}
          {...dimensions}
          onClick={(e) => onClick?.(e)}
          className={className ? className : styles.image}
        />
      </>
    );
  }
  return null;
};

export default CMSImage;
